import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  profile: number;
  description: string;
  industry: number[];
  sector: number[];
}

export const useCreatePortalNatureOfBusiness = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/portal_nature_of_business/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
